<template>
  <div 
    v-loading="loading"
    element-loading-background="rgba(0,0,0,0.3)"
    @mousewheel="mouseHander"
  >
    <el-button class="goBack" @click="goBack">返回</el-button>

    <div class="roadInfoContent">
      <div class="inputContain">
        <div class="inputContent">
          <div class="inputitem">
            <div class="inputLeft">道路名称</div>
            <div class="inputRight">{{ roadInfo.name }}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">道路类型</div>
            <div class="inputRight">
              {{ roadInfo.roadType == 0 ? "标准道路" : "非标准道路" }}
            </div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">道路创建时间</div>
            <div class="inputRight">{{ roadInfo.createTime }}</div>
          </div>
        </div>
        <div class="inputContent">
          <div class="inputitem">
            <div class="inputLeft">道路负责人</div>
            <div class="inputRight">{{ roadInfo.principal }}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">道路联系电话</div>
            <div class="inputRight">{{ roadInfo.phone }}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">已创建层</div>
            <div class="inputRight">{{roadInfo.layers}}</div>
          </div>
        </div>
      </div>
      <div :ref="`cengCon${r.id}`" class="cengCon" v-for="(r,s) in roadTableVoList" :key="s" :style="r.id==''?'display:none':'top:'+cengConTop(s)">
        <div class="title" v-if="r.id!=''">
            <span class="line"></span>
            <span class="name">{{r.roadName}}</span>
            <span class="fudu">{{r.roadway}}</span>
            <span class="area">{{r.mileage==null?r.mileage:r.mileage.toFixed(2)+'m'}}</span>
        </div>
        <div class="order"  v-if="sourceType">
          <div class="up" @click="orderFun('up',r.id)"></div>
          <div class="down" @click="orderFun('down',r.id)"></div>
        </div>
        <div class="canvasCon">
          <div class="canvasContainInfo" v-if="r.id!=''">
            <canvas class="myCanvasInfo" :id="'myCanvas'+s" width="890" height="697"></canvas>
            <canvas class="dhCanvasInfo" :id="'dhCanvas'+s" width="890" height="697"></canvas>
            <div class="infoShow"  v-if="sourceType">
              <el-button class="edit" type="danger" @click="addCengVisible=true;fuzhiFun('修改层',r.roadName,r.roadway,r.id)">修改</el-button>
              <el-button class="delete" type="warning" @click="deleteCeng(r.id)">删除</el-button>
            </div>
          </div>
          <div class="sectionCon" :style="'width:'+sectionwidth(r.roadSections)">
            <div class="sectionItem" v-for="i in r.roadSections" :key="i.id">
              <div class="sectionItemInfo">
                <div class="infoShow">
                  <div class="title">
                    <span class="line"></span>
                    <span class="name">{{i.sectionName}}</span>
                    <span class="area" v-if="i.mileage">{{ (i.mileage).toFixed(2) }} m</span>
                  </div>
                  <div class="imgShow"></div>
                  <span class="startPin">K{{ parseInt(i.startMileage/1000) }}+{{(i.startMileage - (parseInt(i.startMileage/1000)*1000)).toFixed(2)}}</span>
                  <span class="endPin">K{{ parseInt(i.endMileage/1000) }}+{{(i.endMileage - parseInt(i.endMileage/1000)*1000).toFixed(2)}}</span>
                  
                  <div class="lineShow"></div>
                  <el-button
                    class="edit"
                    type="danger"
                    @click="editRoadSection(r.id,i.id)"
                     v-if="sourceType"
                    >修改</el-button
                  >
                  <el-button
                    class="delete"
                    type="warning"
                    plain
                    @click="delRoadSection(i.id)"
                     v-if="sourceType"
                    >删除</el-button
                  >
                </div>
                
              </div>
            </div>
            <div class="sectionItem"  v-if="sourceType">
              <div class="addSection" @click="toRoadSection(roadId,r.id)"></div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
      <el-pageCover
          class="pageBlock"
          :style="'position:absolute;right:20px;top:'+pageConTop"
          :pageMsg="pageMsg"
          :page-sizes="[5]"
          @sizeChange="pageSizeChange"
          @currentChange="currentPageChange"
    ></el-pageCover>
      <div class="addceng" @click="cancelFun();addCengVisible=true;actionName='新增层';" :style="'top:'+addcengTop"  v-if="sourceType">添加新的层</div>
      <el-dialog
        :title="actionName"
        :visible.sync="addCengVisible"
        customClass="addCengPlanning"
        top="35vh"
        append-to-body
        >
        <div>
          <div class="sectionSetItem">
            <div class="itemText"><span style="color:#E96B5A">* </span>层名称：</div>
            <div class="inputCon">
              <el-input
                placeholder="请输入层名称"
                v-model="dialogRoadName"
              ></el-input>
            </div>
          </div>
          <div class="sectionSetItem">
            <div class="itemText"><span style="color:#E96B5A">* </span>所属路幅：</div>
            <div class="inputCon inputCon1">
              <el-select v-model="dialogRoadway" placeholder="请选择所属路幅">
                <el-option
                  v-for="item in roadwayList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="sectionSetItem">
            <div class="itemText"><span style="color:#E96B5A">* </span>上传道路数据：</div>
            <el-upload
              class="upload-demo lookUp_top1"
              ref="upload"
              :action="baseUrl+'/construction/roadStd'"
              :on-change="handlePreview"
              :headers="header"
              :on-remove="handleRemove"
              :on-success="handlerUpload"
              :file-list="fileList"
              :limit="1"
              :data="upData"
              :auto-upload="false">
              <div class="inputCon" style="width:98px;textDecoration:underline;cursor:pointer ">
                选择道路数据
              </div>
            </el-upload>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="submitUpload">确定</el-button>
            <el-button type="info" @click="cancelFun">取消</el-button>
        </span>
        <div style="position:absolute;top:50px;left:0px;width:100%;height:1px;background:rgba(0,0,0,0.3)"></div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { fabric } from "fabric";
import canvasMix from "../../utils/canvasMix";
import {
  getRoadCordInfo,
  getRoadInfo,
  getRoadInfoDetails,
  // getRoadSections,
  // addStdRoadTable,
  resortRoadOrder,
  deleteRoad,
  editRoad,
  deleteRoadSection,
} from "../../utils/api";
import { changeRoadPointer } from "../../utils/commons";
import { Message } from 'element-ui';
import Cookies from 'js-cookie'
import ElPageCover from "../../components/overall/ElPageCover"
export default {
  name: "app",
  mixins: [canvasMix],
  data() {
    return {
      arrowList: [
        // {
        //     name: '首页',
        //     path: '/'
        // },
        // {
        //     name: '工程中心',
        //     path: '/transfer/monitor'
        // },
        {
          name: "道路管理",
          path: "/transfer/roadList",
        },
        {
          name: "道路详情",
          path: "/transfer/roadInfo",
        },
      ],
      roadId: "",
      roadType: "",
      roadInfo: "",
      sections: "",
      panning: false,
      upData: {
        roadInfoId: "4",
        roadName:'层2',
        roadway:'左幅',
        roadType:0,
      },
      upDataShow: true,
      loading:false,
      addCengVisible:false,//新增层和修改层弹窗
      roadwayList:[
          {
              label: '左幅',
              value: '左幅',
          },
          {
              label: '右幅',
              value: '右幅',
          },
      ],
      actionName:'',
      roadTableVoList:[],
      dialogRoadName:'',
      dialogRoadway:'',
      cengid:'',
      cengids:'',
      cengList:[],
      fileList:[],
      sourceType:'',
      canvasM:'',
      contextM:"",
      baseUrl:'',
      header:'',
      pageMsg: {
          pageSize: 5,
          pageNo: 1,
          totalRecords: 0
      },
    };
  },
  computed: {
    sectionwidth(){
      return (arr)=>{
        if(arr==undefined) return
        if(arr.length<=3){
          return '970px'
        }else{
          return (parseInt(arr.length/2)-1)*460+970+'px'
        }
      }
    },
    cengConTop(){
       return (s)=>{
          return (s*796+170)+'px'
      }
    },
    addcengTop(){
      if(this.sourceType){
        return this.roadTableVoList.length*796+210+'px'
      }else{
        return this.roadTableVoList.length*796+170+'px'
      }
    },
    pageConTop(){
      return this.roadTableVoList.length*796+150+'px'
    }
  },
  created() {
    this.pageMsg.pageNo=this.$route.params.pageNo || 1
  },
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.roadId = this.$route.query.id || this.$store.state.nowRoadId;
    this.$store.commit("setNowRoadId", this.roadId);
    this.baseUrl=this.$store.state.baseUrl
    this.header={token:Cookies.get('token'),Authorization:Cookies.get('token')}
    // this.upData.roadId = this.roadId;
    this.loading=true
    this.getRoadInfoDetailsFun();
    
    // initCanvas()
  },
  beforeDestroy() {
    this.$store.commit("setNowRoadId", "");
  },
  methods: {
    pageSizeChange(size){
      this.pageMsg.pageSize=size;
    },
    currentPageChange(index){
      this.pageMsg.pageNo=index;
      this.$router.push({name:'Trans',params:{pageNo:this.pageMsg.pageNo,type:0}})
    },
    mouseHander(e){
      console.log(e)
      // if(e.target.nodeName=='CANVAS'){
      //   e.preventDefault()
      // }else{
      //   e.cancelBubble =true
      // }
    },
     handleRemove(file, fileList) {
        console.log(file, fileList);
      },
    handlePreview(file,fileList){
      console.log(file,fileList,'file');
      this.fileList=fileList
    },
    //对层进行排序
    orderFun: function(type,id){
      let maxIndex=this.roadTableVoList.length
      let findindex=this.cengList.findIndex(item=>{return item=='cengCon'+id})
      // console.log(this.roadTableVoList,'this.roadTableVoList')
      console.log(findindex,this.cengList,'cengList')
      if(findindex==maxIndex-1 && type=='down') return
      if(findindex==0 && type=='up') return
      let arr=[]
      let ceng=[]
      if(type=='up'){
        this.cengList.map((item,index)=>{
          if(index==findindex-1){
            arr.push(this.cengList[findindex])
          }else if(index==findindex){
            arr.push(this.cengList[findindex-1])
          }else{
            arr.push(item)
          }
        })
      }else if(type=='down'){
        this.cengList.map((item,index)=>{
          if(index==findindex){
            arr.push(this.cengList[findindex+1])
          }else if(index==findindex+1){
            arr.push(this.cengList[findindex])
          }else{
            arr.push(item)
          }
        })
      }
      arr.map((j,s)=>{
          ceng.push(j.substr(7))
          this.$refs[`cengCon${j.substr(7)}`][0].style.top=s*796+170+'px'
        })
      this.cengids=ceng.join(',')
      this.cengList=[...arr]
      resortRoadOrder({ids:this.cengids})
    },
    //修改层时赋值
    fuzhiFun(action,roadName,roadWay,id){
      this.actionName=action
      this.dialogRoadName=roadName
      this.dialogRoadway=roadWay
      this.fileList=[]
      this.cengid=id
    },
    async getRoadInfoDetailsFun(){
      this.loading=true
      let params = {
        id: this.roadId,
        pageSize:this.pageMsg.pageSize,
        pageNo:this.pageMsg.pageNo,
      };
      getRoadInfo({roadId: this.roadId,pageSize: 100}).then((res) => {
        this.roadInfo = res.data.content.info;
        this.sourceType = res.data.content.info.sourceType
        this.roadType = res.data.content.info.roadType;
      })
      let res=await getRoadInfoDetails(params)
        this.loading=false
        this.roadTableVoList=JSON.parse(JSON.stringify(res.data.content.info.list))
        this.pageMsg.totalRecords=res.data.content.info.totalRecords
        let _roadTableVoList=JSON.parse(JSON.stringify(this.roadTableVoList))
        this.cengList=[]
        this.$nextTick(function () {
          this.roadTableVoList.map((item,index)=>{
              if(item.id){
                this.cengList.push('cengCon'+item.id)
                getRoadCordInfo({roadId: item.id}).then(res => {
                    let changeObj = changeRoadPointer(890, 697, res.data.content.dataMap,false);
                    // console.log(changeObj);
                    let getChangeObj = changeObj[0];
                    let scaleCode = changeObj[1];
                    this.$store.commit("setScaleCode", scaleCode);
                    this.setGrid("#ffffff",'myCanvas'+index);
                    var canvas = new fabric.Canvas("dhCanvas"+index, {
                        perPixelTargetFind: true,
                    });
                    canvas.selectable = false;
                    this.initCanvas1(canvas,"", getChangeObj, 1);
                })
              }
          })
      });
      this.doInit(_roadTableVoList);
      this.loading=false
    },
    setGrid(color,canvas){
        // console.log(color)
        // let colorValue = color ? color : 'RGB(224,224,225)'
        let myCanvas = document.getElementById(canvas);
        let ctx = myCanvas.getContext('2d');
        // let heightValue = myCanvas.height
        // myCanvas.height = heightValue
        let gridSize = 50;
        let canvasWidth = ctx.canvas.width;
        let canvasHeight = ctx.canvas.height;

        let xLineTotal = Math.floor(canvasHeight / gridSize);
        let yLineTotal = Math.floor(canvasWidth / gridSize);
        ctx.fillStyle = '#E1E0E0';
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.stroke();

        for (let i = 0; i <= xLineTotal; i++) {
            ctx.beginPath();
            ctx.moveTo(0, i * gridSize - 0.5);
            ctx.lineTo(canvasWidth, i * gridSize - 0.5);
            ctx.strokeStyle = '#D8D6D4';
            ctx.stroke();
        }

        for (let i = 0; i <= yLineTotal; i++) {
            ctx.beginPath();
            ctx.moveTo(i * gridSize - 0.5, 0);
            ctx.lineTo(i * gridSize - 0.5, canvasHeight);
            ctx.strokeStyle = '#D8D6D4';
            ctx.stroke();
        }
    },
    submitUpload() {
      if(this.dialogRoadName==''){
        this.$message({
            message: "请填写层名称!",
            type: "warning"
        });
        return
      } 
      if(this.dialogRoadway==''){
        this.$message({
            message: "请选择所属路幅!",
            type: "warning"
        });
        return
      } 
      
      this.upData.roadInfoId=this.roadId
      this.upData.roadway=this.dialogRoadway
      this.upData.roadName=this.dialogRoadName
      console.log(this.fileList,'this.fileList')
      if(this.actionName=='新增层'){
        this.$refs.upload.submit();
      }else if(this.actionName=='修改层' &&this.fileList.length==0){
        let params={id:this.cengid,roadName:this.dialogRoadName,roadway:this.dialogRoadway,sourceType:1}
        editRoad(params).then((res) => {
          if(res.data.code==200){
            this.$message({
              message: "修改成功!",
              type: "success"
            });
            this.addCengVisible=false
            this.getRoadInfoDetailsFun()
          }
        });
      }else if(this.actionName=='修改层' &&this.fileList.length==1){
        this.upData.id=this.cengid
        this.upData.sourceType=1
        this.$refs.upload.submit();
      }
    },
    cancelFun(){
      this.addCengVisible = false
      this.dialogRoadway=''
      this.dialogRoadName=''
      this.fileList=[]
      this.upData = {
        roadInfoId: this.roadId,
        roadName:'',
        roadway:'',
        roadType:0,
      }
    },
    doInit: function (getArr) {
      // getRoadSections(params).then((res) => {
      //   //console.log(res)
      //   let getArr = res.data.content.info.list;
        getArr.push({ id: "" });
        let setArr = [];
        let endArr = [];
        if (getArr.length % 2 == 0) {
          for (let i = 0; i < getArr.length; i++) {
            setArr.push(getArr[i]);
            if (i % 2 == 1) {
              endArr.push(setArr);
              setArr = [];
            }
          }
        } else {
          for (let i = 0; i < getArr.length; i++) {
            setArr.push(getArr[i]);
            if (i % 2 == 1) {
              endArr.push(setArr);
              setArr = [];
            }
          }
          endArr.push([getArr[getArr.length - 1]]);
        }
        this.sections = endArr;
      // });
    },
    goBack: function () {
      this.$router.push({ name: "RoadList" });
    },
    deleteCeng: function(e){
      this.$confirm("删除层会将该层下的各标段全部删除，可能影响关联作业,请谨慎确认是否删除。", "删除层",{
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          deleteRoad({ids:e}).then(res=>{
            if(res.data.code==200){
              this.$message({
                  message: "删除成功!",
                  type: "success"
              });
              this.getRoadInfoDetailsFun()
            }
          })
        });
    },
    toRoadSection: function (e,e1) {
      this.$router.push({
        name: "RoadSection",
        query: { id: e,cengid:e1, type: "add", roadType: this.roadType },
      });
    },

    editRoadSection: function (e1,e2) {
      //console.log(e)
      this.$router.push({
        name: "RoadSection",
        query: {
          id: this.roadId,
          cengid:e1,
          sectionId: e2,
          type: "edit",
          roadType: this.roadType,
        },
      });
    },
    delRoadSection: function (e) {
      //console.log(e)
      this.$confirm("删除标段可能会影响关联的作业,请谨慎确认是否删除。", "删除标段", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        let params = {};
        params.ids = e;
        deleteRoadSection(params).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "删除成功!",
              type: "success",
            });
          }
          this.getRoadInfoDetailsFun()
        });
      });
    },
    handlerUpload: function (res,file, fileList) {
      console.log("upload");
      console.log(file);
      console.log(fileList);
      this.upDataShow = true;
      this.loading=true
      if(res.code==1000){
        Message.warning(res.message)
      }else{
        this.addCengVisible=false
        this.fileList=[]
        this.pageMsg.pageNo=1
        this.getRoadInfoDetailsFun()
      }
    },
    handlerProgress: function () {
      console.log("加载中");
      this.upDataShow = false;
    },
  },
  watch:{
    loading(newV){
      if(newV){
        setTimeout(()=>{
          this.loading=false
        },20000)
      }
    },
    // roadTableVoList:function(){
    //   this.$nextTick(function () {
    //       this.roadTableVoList.map((item,index)=>{
    //         if(item.id){
    //             getRoadCordInfo({roadId: item.id}).then(res => {
    //             let changeObj = changeRoadPointer(890, 697, res.data.content.dataMap);
    //             // console.log(changeObj);
    //             let getChangeObj = changeObj[0];
    //             let scaleCode = changeObj[1];
    //             this.$store.commit("setScaleCode", scaleCode);
    //             this.setGrid("#ffffff",'myCanvas'+index);
    //             var canvas = new fabric.Canvas("dhCanvas"+index, {
    //                 perPixelTargetFind: true,
    //             });
    //             canvas.clear()
    //             canvas.selectable = false;
    //             // console.log('dhCanvas'+index)
    //             this.initCanvas1(canvas,"", getChangeObj, 1);
    //             })
    //         }
    //     });
    //   })     
    //   let _roadTableVoList=JSON.parse(JSON.stringify(this.roadTableVoList))
    //     this.doInit(_roadTableVoList);
    // }
  },
  components: {ElPageCover},
};
</script>
<style lang="scss">
.canvasContainInfo {
  .canvas-container {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
  }
}
.addCengPlanning{
        width: 35% !important;
        height: 320px !important;
        .el-dialog__header{
            .el-dialog__title{
               font-weight: 600 !important;
               padding-left: 10px;
               line-height: 20px !important;
            }
        }
        .el-dialog__body{
            font-size: 16px !important;
            padding-left: 150px;
        }
        .el-dialog__footer{
            .dialog-footer{
                display: flex !important;
                justify-content: space-around !important;
                .el-button{
                    width: 110px !important;
                    height: 40px !important;
                    font-size: 16px !important;
                    border-radius: 5px !important;
                }
            }
        }
        .el-input__inner{
          font-size: 16px !important;
        }
    }
</style>
<style lang="scss" scoped="">
.lookUp {
  position: fixed;
  right: 187px;
  top: 68px;
  height: 35px !important;
  z-index: 999;
}
.lookUp_top {
  position: fixed;
  right: 187px;
  top: 68px;
  height: 35px !important;
  width: 95px;
  z-index: 999;
  .lookUp_btn {
    position: fixed;
    right: 187px;
    top: 68px;
    height: 35px !important;
    width: 95px;
    z-index: 1000;
    opacity: 0;
  }
}
.downLoad {
  position: fixed;
  right: 89px;
  top: 68px;
  height: 35px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  z-index: 999;
}
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  height: 35px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
  z-index: 999;
}
.roadInfoContent {
  width: 100%;
  min-height: 500px;
  padding: 0 15px;
  .inputContain {
    border-top: 1px solid rgba(225, 225, 225, 1);
    border-left: 1px solid rgba(225, 225, 225, 1);
  }
  .inputContent {
    width: 100%;
    height: 45px;
    display: flex;

    .inputitem {
      display: flex;
      width: 33.3%;
      .inputLeft {
        width: 25.8%;
        height: 45px;
        background-color: #e1e1e1;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 45px;
        padding-left: 16px;
        color: #555555;
        font-size: 14px;
      }
      .inputRight {
        width: 74.2%;
        height: 45px;
        background-color: #ffffff;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 45px;
        padding-left: 16px;
        color: #555555;
        font-size: 14px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.cengCon{
  height: 785px;
  width: 1885px;
  background-color: #ffffff;
  border: 1px solid rgba(225, 225, 225, 1);
  padding:0 20px;
  overflow: hidden;
  position: absolute;
  left: 50%;
  margin-left: -943px;
  .title{
    width: 1200px;
    height: 50px;
    font-size: 20px;
    position: absolute;
    top: 10px;
    left: 20px;
    display: flex;
    align-items: center;
    .line{
      display: inline-block;
      width: 5px;
      height: 25px;
      background: #FF0000;
      margin-right: 10px;
    }
    .name{
      font-weight: bold;
    }
    .fudu{
      display: inline-block;
      height: 35px;
      margin-left: 10px;
      line-height: 35px;
      padding: 0 10px;
      background: rgba(254, 235, 232, 1);
      color: #e96b5a;
    }
    .area{
      display: inline-block;
      height: 35px;
      background: rgba(225, 235, 250, 1);
      color: #2273f8;
      margin-left: 10px;
      line-height: 35px;
      padding: 0 10px;
    }
  }
  .order{
    width: 64px;
    height: 32px;
    font-size: 20px;
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    .up{
      width: 32px;
      height: 32px;
      background: url('../../images/all/shangjiantou.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    .down{
      width: 32px;
      height: 32px;
      background: url('../../images/all/xiajiantou.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .canvasCon {
    height: 785px;
    width: 1880px;
    overflow-x: scroll;
    display: flex;
    .canvasContainInfo {
      height: 697px;
      width: 890px;
      margin: 67px 0 0 0px;
      border: 1px solid rgba(211, 207, 206, 1);
      flex-shrink: 0;
      position: relative;
      .myCanvasInfo {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
      }
      .dhCanvasInfo {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
      }
      .infoShow {
        width: 100%;
        .infoTypeShow {
          height: 22px;
          position: absolute;
          width: auto;
          top: 23px;
          left: 23px;
        }
        .edit {
          position: absolute;
          top: 22px;
          right: 91px;
        }
        .delete {
          position: absolute;
          top: 22px;
          right: 30px;
        }
      }
    }
    .sectionCon {
      height: 711px;
      min-width: 970px;
      display: flex;
      margin: 67px 0 0 0px;
      // background-color: antiquewhite;
      flex-shrink: 0;
      flex-wrap: wrap;
      .sectionItem {
        width: 440px;
        height: 340px;
        margin: 0 0 0 20px;
        .addSection {
          width: 100%;
          height: 340px;
          background-image: url("../../images/all/addSection.png");
          margin: 0 0 18px 0;
          cursor: pointer;
        }
        .sectionItemInfo {
          height: 340px;
          width: 100%;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(211, 207, 206, 1);
          margin: 0 0 18px 0;
          .infoShow {
            height: 100%;
            width: 100%;
            
            position: relative;
            // .lineShow {
            //   width: 417px;
            //   height: 1px;
            //   position: absolute;
            //   background: rgba(225, 225, 225, 1);
            //   left: 50%;
            //   transform: translateX(-50%);
            //   top: 75px;
            // }
            .title{
              width: 300px;
              height: 50px;
              font-size: 16px;
              position: absolute;
              top: 15px;
              left: 20px;
              display: flex;
              align-items: center;
              z-index: 100;
              .line{
                display: inline-block;
                width: 4px;
                height: 20px;
                background: #FF0000;
                margin-right: 6px;
              }
              .name{
                max-width: 190px;
                font-weight: bold;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              .area{
                display: inline-block;
                height: 28px;
                background: rgba(225, 235, 250, 1);
                color: #2273f8;
                margin-left: 6px;
                line-height: 28px;
                padding: 0 6px;
              }
            }
            // .infoTypeShow {
            //   height: 22px;
            //   position: absolute;
            //   width: auto;
            //   top: 43px;
            //   left: 23px;
            //   .type {
            //     font-size: 14px;
            //     padding: 5px 8px;
            //     margin-right: 6px;
            //     float: left;
            //     line-height: 12px;
            //   }
            //   .type_1 {
            //     background: rgba(225, 235, 250, 1);
            //     color: #2273f8;
            //   }
            //   .type_2 {
            //     background: rgba(254, 235, 232, 1);
            //     color: #e96b5a;
            //   }
            //   .type_3 {
            //     background: rgba(221, 240, 229, 1);
            //     color: #10bd62;
            //   }
            // }
            .edit {
              position: absolute;
              top: 22px;
              right: 71px;
            }
            .delete {
              position: absolute;
              top: 22px;
              right: 13px;
            }
            
            .iconShow {
              width: 4px;
              height: 16px;
              background: rgba(233, 107, 90, 1);
              position: absolute;
              top: 18px;
              left: 13px;
            }
            .itemTitle {
              height: 15px;
              line-height: 15px;
              font-size: 15px;
              color: #222222;
              position: absolute;
              top: 19px;
              left: 26px;
            }
            .imgShow {
              height: 223px;
              width: 385px;
              position: absolute;
              background-image: url("../../images/all/section.png");
              top: 85px;
              left: 27px;
            }
            .startPin {
              font-size: 12px;
              font-weight: bold;
              display: inline-block;
              text-align: right;
              position: absolute;
              z-index: 100;
              top: 190px;
              right: 300px;
            }
            .endPin {
              font-size: 12px;
              font-weight: bold;
              display: inline-block;
              text-align: left;
              position: absolute;
              z-index: 100;
              top: 190px;
              left: 310px;
            }
          }
        }
      }
    }
  }
}

.addceng{
  height: 160px;
  padding: 0 15px;
  width: 1885px;
  position: absolute;
  left: 50%;
  margin-left: -943px;
  margin-bottom: 11px;
  background-color: #ffffff;
  background-image: url('../../images/all/add.jpg');
  background-repeat: no-repeat;
  background-position: 50% 50%;
  color: #e96b5a;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  text-indent: 270px;
  line-height: 160px;
  cursor: pointer;
}
.addCengPlanning{
  .sectionSetItem {
    width: 100%;
    height: 35px;
    margin-top: 11px;
    display: flex;
    justify-content: left;
    .itemText {
      height: 35px;
      line-height: 35px;
      width: auto;
      padding-left: 18px;
      color: #222222;
      font-size: 16px;
    }
    .inputCon {
      height: 35px;
      width: 218px;
      margin-left: 36px;
      line-height: 35px;
      color: #282828;
      .el-input {
        height: 35px;
        width: 218px;
        input {
          height: 35px !important;
          width: 218px !important;
          border-radius: 0;
          font-size: 16px !important;
        }
      }
      .lookUp_top1 {
        position: absolute;
        right: 17px;
        top: 68px;
        height: 35px !important;
        width: 95px;
        z-index: 999;
      }
    }
    .inputCon1{
      margin-left: 20px;
    }
  }
}
</style>